var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("正在跳转到招商银行......")]),_c('form',{ref:"banckConfirmForm",staticStyle:{"display":"none"},attrs:{"id":"banckConfirmForm","method":"post"}},[_c('input',{attrs:{"type":"text","name":"data","id":"banckTxtData"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }